import { gql } from 'apollo-angular';

export const dossierStatusesForProcessTypeQuery = gql`
    query DossierStatusesForProcessType($processType: ProcessTypeInput)  {
        dossierStatusesForProcessType(processType: $processType) {
            id
            description
        }
    }
`;
